import React from 'react';
import LogoRdstation from 'images/logo-white.svg';

const MainHeader = (props) => {
  return (
    <nav className='navbar navbar-dark navbar-expand-md bg-secondary pl-sm-0 pr-sm-0'>
      <div className='container-fluid'>
        <a href="#" className="navbar-brand">
          <img alt='RD Station Logo' src={LogoRdstation} width='200' />
        </a>
      </div>
    </nav>
  );
};

export default MainHeader;
